import styled from 'styled-components'

import { DefaultTemplate } from '~/components/templates'
import { color, device } from '~/styles/utils'

export const CartTemplate = styled(DefaultTemplate)`
  color: ${({ theme }) => theme.color.text.default};
  section.single-content {
    background-color: ${color('lightestGrey')};
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    @media ${device('notMobile')} {
      flex-direction: row;
    }
  }
`

export const MainContent = styled.div`
  background-color: ${({ theme }) => theme.color.background.default};

  &&& {
    @media ${device('notMobile')} {
      flex: 1;
    }
  }
`

export const CenteredContent = styled.div`
  margin: 0 auto;
  padding: 0 16px;

  @media ${device('notMobile')} {
    max-width: 666px;
  }
`

export const OrderSummaryContents = styled.div`
  width: 100%;
  flex: 0 0 347px;

  @media ${device('notMobile')} {
    flex: 0 0 490px;
  }
`
